// Laravel returns pagination either in `meta` or alongside `data`.
export const paginationMeta = (body) => body.meta || body;

export async function fetchAllPages(fetchPage, query = {}) {
    const items = [];
    let page = 1;
    while (page > 0) {
        const body = await fetchPage({...query, page, pageSize: 100});
        if (Array.isArray(body)) {
            if (page !== 1) throw new Error('De lijst kon niet volledig worden geladen.');
            return body;
        }
        if (!Array.isArray(body?.data)) throw new Error('De lijst kon niet worden geladen.');
        const meta = paginationMeta(body);
        if (meta.current_page !== undefined && Number(meta.current_page) !== page) {
            throw new Error('De volgende pagina kon niet worden geladen.');
        }
        items.push(...body.data);
        const lastPage = Number(meta.last_page);
        if (!Number.isInteger(lastPage) || lastPage < 1) {
            if (body.links?.next || body.next_page_url) {
                if (body.data.length === 0) throw new Error('De lijst kon niet volledig worden geladen.');
                page++;
                continue;
            }
            return items;
        }
        if (page >= lastPage) return items;
        if (body.data.length === 0) throw new Error('De lijst kon niet volledig worden geladen.');
        page++;
    }
}
